import React, { useState } from "react";

import styles from "./FormContent.css";

import FormFields from "./FormFields";

import { Input } from "./Input";
import Label from "./Label";
import Button from "./Button";
import Radiobutton from "./Radiobutton";

import Attachment from "./Attachment";

import { useDate, useCurrency } from "./Format";
import { nominalTypeHack } from "prop-types";
import Checkbox from "./Checkbox";
import { OfferTable } from "../offers";
import { format, parseISO } from "date-fns";

const FormContent = function ({
    participantDefaults,
    form,
    data,
    capacityData,
    dispatch,
    formRef,
    formSubmit,
}) {
    const date = useDate();
    const currency = useCurrency();
    const [disableSubmitButton, setDisableSubmitButton] = useState(false)
    const fields = data?.fields.filter((field) => field.inChild == false) || [];
    const offers = data?.offers[0] || [];

    const fieldsInChild = data?.fields.filter((field) => field.inChild) || [];

    const toggleRole = (roleId) => {
        dispatch({ type: "TOGGLE_ROLE", payload: roleId });
    };

    const updateGeneralInformation = function (field, value) {
        dispatch({
            type: "UPDATE_GENERAL_INFORMATION",
            payload: { section: "general", field, value },
        });
    };

    const updateGeneralField = function (field, value) {
        dispatch({
            type: "UPDATE_GENERAL_FIELD",
            payload: { section: "general", field: field.id, value },
        });
    };

    const updateParticipantInformation = function (
        participantIndex,
        field,
        value
    ) {
        dispatch({
            type: "UPDATE_PARTICIPANT_INFORMATION",
            payload: { participantIndex, field, value },
        });
    };

    function toggleDate(participantIndex, offerId, date) {
        const offer = offers.filter(o => o.id == offerId)[0]
        dispatch({
            type: "TOGGLE_DATE",
            payload: { participantIndex, offer, date }
        })
    }

    const updateParticipantField = function (participantIndex, field, value) {
        dispatch({
            type: "UPDATE_PARTICIPANT_FIELD",
            payload: { index: participantIndex, field, value },
        });
    };

    const addParticipant = function () {
        dispatch({
            type: "ADD_PARTICIPANT",
            participantDefaults: participantDefaults,
        });
    };

    const deleteParticipant = function (index) {
        dispatch({ type: "REMOVE_PARTICIPANT", payload: index });
    };

    const requestFormSubmit = () => {
        formRef.current.setAttribute("data-submitted", true);
        setDisableSubmitButton(true)
        setTimeout(() => setDisableSubmitButton(false), 3000)

        if (formRef.current.requestSubmit) {
            formRef.current.requestSubmit();
        } else {
            if (!formRef.current.checkValidity()) {
                formRef.current.reportValidity();
                return;
            }

            formSubmit()
        }
    };

    const allOffers = form.participants.flatMap((p) => p.offers);
    const aParticipantIsEmpty = form.participants.map((p) => p.offers).some(offers => offers.length == 0)

    const participantCalculation = function (participant, participantIndex) {
        if (!form.roleId) return null;
        const role = data.roles.filter(role => role.id == form.roleId)[0]
        const prices = {
            price: parseFloat(role.price),
            weekPrice: parseFloat(role.weekPrice),
            discountPrice: parseFloat(role.discountPrice),
            weekDiscountPrice: parseFloat(role.weekDiscountPrice),
        }


        return participant.offers.reduce((sum, offer, offerIndex) => {
            let price = offer.isWeek ? prices.weekPrice : prices.price
            let discountPrice = offer.isWeek ? prices.weekDiscountPrice : prices.discountPrice



            if (offer.isWeek && offer.bookableDays < 5) {
                price = (price / 5 * offer.bookableDays)
                discountPrice = (discountPrice / 5 * offer.bookableDays)
            }

            console.log({ price, discountPrice, offer })

            switch (data.camp.discountType) {
                case "CHILD":
                    return sum + (participantIndex > 0 ? discountPrice : price)
                case "OFFER":
                    return sum + (offerIndex > 0 ? discountPrice : price)
                default:
                    return sum + price
            }


        }, 0.0)
    }

    const totalCalculation = function () {
        return form.participants.reduce((sum, participant, participantIndex) => {
            return sum + participantCalculation(participant, participantIndex)
        }, 0.0)
    };

    const isWaitingList = function (offer, date) {
        console.warn({ capacityData, offer, date })
        const offerCapacity = capacityData ? capacityData[offer.id.toString()] : null;
        if (offerCapacity) {
            return offerCapacity[format(date, 'yyyy-MM-dd')] <= 0
        }
    }

    // render data
    return (
        <form ref={formRef} className={styles.Form} onSubmit={formSubmit}>
            <section className={styles.Section}>
                <p>Status:</p>
                <div className={styles.EmployeeStatus}>
                    {data.roles.map(role => <Radiobutton
                        name="status"
                        value={role.id}
                        checked={form.roleId == role.id}
                        onChange={(e) => toggleRole(role.id)}
                    >
                        {role.name}
                    </Radiobutton>)}
                </div>
            </section>

            <h2>Angaben der Eltern</h2>
            <section className={styles.SectionWithBorder}>
                <Input.Group>
                    <Label label="Vorname">
                        <Input
                            required
                            value={form.general.firstName}
                            onChange={(e) =>
                                updateGeneralInformation(
                                    "firstName",
                                    e.target.value
                                )
                            }
                        />
                    </Label>
                    <Label label="Nachname">
                        <Input
                            required
                            value={form.general.lastName}
                            onChange={(e) =>
                                updateGeneralInformation(
                                    "lastName",
                                    e.target.value
                                )
                            }
                        />
                    </Label>
                </Input.Group>
                <Input.Group>
                    <Label label="Straße Hausnummer ">
                        <Input
                            required
                            value={form.general.street}
                            onChange={(e) =>
                                updateGeneralInformation(
                                    "street",
                                    e.target.value
                                )
                            }
                        />
                    </Label>
                    <Label label="PLZ Ort ">
                        <Input
                            required
                            value={form.general.location}
                            onChange={(e) =>
                                updateGeneralInformation(
                                    "location",
                                    e.target.value
                                )
                            }
                        />
                    </Label>
                </Input.Group>
                <Input.Group>
                    <Label label="Telefon">
                        <Input
                            required
                            value={form.general.phonePrivate}
                            type="tel"
                            onChange={(e) =>
                                updateGeneralInformation(
                                    "phonePrivate",
                                    e.target.value
                                )
                            }
                        />
                    </Label>
                    <Label label="E-Mail ">
                        <Input
                            required
                            value={form.general.emailPrivate}
                            type="email"
                            onChange={(e) =>
                                updateGeneralInformation(
                                    "emailPrivate",
                                    e.target.value
                                )
                            }
                        />
                    </Label>
                </Input.Group>

                <Input.Group fieldset>
                    <Label label="Telefon (geschäftlich oder alternativ)">
                        <Input
                            required
                            value={form.general.phoneBusiness}
                            type="tel"
                            onChange={(e) =>
                                updateGeneralInformation(
                                    "phoneBusiness",
                                    e.target.value
                                )
                            }
                        />
                    </Label>
                    <Label label="E-Mail (geschäftlich oder alternativ)">
                        <Input
                            required
                            value={form.general.emailBusiness}
                            type="email"
                            onChange={(e) =>
                                updateGeneralInformation(
                                    "emailBusiness",
                                    e.target.value
                                )
                            }
                        />
                    </Label>
                </Input.Group>
                <h4>Zusätzliche Informationen</h4>

                <FormFields
                    idPrefix="general"
                    fields={fields}
                    values={form.general.fields}
                    onFieldChange={updateGeneralField}
                />
            </section>
            <div className={styles.HeaderWithButton}>
                <h2>Teilnehmer:in</h2>
            </div>
            {form.participants.map((participant, participantIndex) => (
                <section
                    key={participantIndex}
                    className={styles.SectionWithBorder}
                >
                    <div className={styles.Participant}>
                        <div className={styles.FlexBetwContainer}>
                            <h3>{`Kind ${participantIndex + 1}`}</h3>
                            {form.participants.length > 1 && (
                                <div className={styles.FlexStartContainer}>
                                    <Button
                                        secondary
                                        onClick={() =>
                                            deleteParticipant(participantIndex)
                                        }
                                    >
                                        Kind entfernen
                                    </Button>
                                </div>
                            )}
                        </div>
                        <Input.Group>
                            <Label label="Vorname">
                                <Input
                                    required
                                    value={
                                        form.participants[participantIndex]
                                            .firstName
                                    }
                                    onChange={(e) =>
                                        updateParticipantInformation(
                                            participantIndex,
                                            "firstName",
                                            e.target.value
                                        )
                                    }
                                />
                            </Label>
                            <Label label="Nachname">
                                <Input
                                    required
                                    value={
                                        form.participants[participantIndex]
                                            .lastName
                                    }
                                    onChange={(e) =>
                                        updateParticipantInformation(
                                            participantIndex,
                                            "lastName",
                                            e.target.value
                                        )
                                    }
                                />
                            </Label>
                        </Input.Group>
                        <Input.Group>
                            <Label label="Geb.-Datum">
                                <Input
                                    required
                                    value={
                                        form.participants[participantIndex]
                                            .birthDate
                                    }
                                    type="date"
                                    onChange={(e) =>
                                        updateParticipantInformation(
                                            participantIndex,
                                            "birthDate",
                                            e.target.value
                                        )
                                    }
                                />
                            </Label>
                        </Input.Group>
                        <FormFields
                            idPrefix={participantIndex}
                            fields={fieldsInChild}
                            values={participant.fields}
                            onFieldChange={(field, value) =>
                                updateParticipantField(
                                    participantIndex,
                                    field,
                                    value
                                )
                            }
                        />
                        <h4>Angebote</h4>

                        <div className={styles.Offers}>
                            {form.roleId ?
                                <OfferTable capacityData={capacityData}>
                                    {offers.filter(o => o.roles.includes(form.roleId)).map(offer => <OfferTable.Item
                                        title={offer.name}
                                        daily={!!offer.daily}
                                        isWaitingList={(date) => isWaitingList(offer, date)}
                                        selectedDates={participant.offers.filter(o => o.id == offer.id).map(o => parseISO(o.date))}
                                        begin={parseISO(offer.dateBegin)}
                                        end={parseISO(offer.dateEnd)}
                                        onToggleDate={(date) => toggleDate(participantIndex, offer.id, date)}
                                    />)}
                                </OfferTable> : <p>Bitte wählen Sie zuerst Ihren Status aus.</p>}
                        </div>
                    </div>
                </section>
            ))}
            <div className={styles.FlexEndContainer}>
                <Button type="button" onClick={() => addParticipant()}>
                    + Kind hinzufügen
                </Button>
            </div>
            <h2>Zusammenfassung</h2>
            <section className={styles.SectionWithBorder}>
                <table className={styles.Table}>
                    <thead>
                        <tr>
                            <th>Kind</th>
                            <th align="right">Gebühr</th>
                        </tr>
                    </thead>
                    {form.participants.map((participant, index) => (
                        <tbody>
                            <React.Fragment key={index}>
                                <tr>
                                    <td
                                        className={
                                            form.participants?.length > 1
                                                ? styles.TableDevider
                                                : null
                                        }
                                    >
                                        {participant.firstName == "" &&
                                            participant.lastName == ""
                                            ? "N.N."
                                            : participant.firstName +
                                            " " +
                                            participant.lastName}
                                    </td>
                                    <td style={{ textAlign: "right" }}>
                                        {currency(participantCalculation(participant, index))}
                                    </td>
                                </tr>

                            </React.Fragment>
                        </tbody>
                    ))}
                    <tfoot>
                        <tr>
                            <th>Gesamt</th>
                            <th align="right">
                                {currency(totalCalculation())}
                            </th>
                        </tr>
                    </tfoot>
                </table>
                <br />
                <ul className={styles.List}>
                    {data?.attachments
                        .filter((a) => !a.required)
                        .map((attachment) => (
                            <li>
                                <Attachment attachment={attachment} />
                            </li>
                        ))}
                </ul>
                {data?.attachments
                    .filter((a) => a.required)
                    .map((attachment) => (
                        <Attachment attachment={attachment} />
                    ))}

                <p>
                    <Checkbox onChange={(e) => updateGeneralInformation("useWaitingList", e.target.checked)}>
                        Ich möchte, dass meine Anmeldung auf die Warteliste gesetzt wird, sofern einzelne Programme bereits ausgebucht sind.
                    </Checkbox>
                </p>
            </section>

            <section className={styles.FormFooter}>
                <Button secondary>abbrechen</Button>
                <Button
                    type="button"
                    disabled={disableSubmitButton || allOffers.length == 0 || aParticipantIsEmpty}
                    onClick={() => requestFormSubmit()}
                >
                    verbindlich anmelden
                </Button>
            </section>
        </form >
    );
};
export default FormContent;
function offerStatus(offer) {
    return (offer.limit - offer.reservations) <= 0 && offer.limitWaiting > offer.reservationsWaiting
        ? "Warteliste"
        : "Buchung";
}
